import React from 'react';

import type { SidebarIconComponent } from './sidebarIcons';

interface SidebarNavIconProps {
  icon: SidebarIconComponent;
}

export const SidebarNavIcon: React.FC<SidebarNavIconProps> = ({ icon: Icon }) => (
  <Icon sx={{ color: 'inherit', width: '35px', height: '35px', fontSize: '35px', flexShrink: 0 }} />
);
